import { cn } from '@utils/cn';
import { type ComponentProps } from 'react';

const TimeLine = ({
  className,
  children,
  space = 20,
  ...props
}: ComponentProps<'ol'> & { space?: number }) => {
  return (
    <ol
      style={{
        gap: space,
      }}
      className={cn('relative ml-4 grid', className)}
      {...props}
    >
      {children}
    </ol>
  );
};

export { TimeLine };
